import { Component, OnInit, Input } from '@angular/core';
import { Guiaremision } from '../../../models/guiaremision';
import { GuiaremisionDetalle } from '../../../models/guiaremision_detalle';
import { GuiaremisionService } from '../../../services/guiaremision.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-guiaremision-modal',
  templateUrl: './guiaremision-modal.component.html',
  styleUrls: ['./guiaremision-modal.component.css'],
  providers: [GuiaremisionService]
})
export class GuiaremisionModalComponent implements OnInit {
    @Input() guiaremision_id: String;
    public guiaremision: Guiaremision;
    public loading = false;
    public guiaremision_detalle: Array<GuiaremisionDetalle>;
  
  constructor(
    private guiaremisionService: GuiaremisionService,
    public bsModalRef: BsModalRef
  ) { 
    this.guiaremision = new Guiaremision();
    this.guiaremision_detalle = [];
  }

  ngOnInit(){
      this.getGuiaById();
  }

  getGuiaById(){
      this.loading = true;
      let qs = "?embed=cliente,tipocomprobante,estadobitacora,venta,detalle?embed=producto";
      this.guiaremisionService.getById(this.guiaremision_id, qs).subscribe(
          res => {
              this.loading = false;
              this.guiaremision = res;
              // this.guiaremision_detalle = [];

              // let guiaremision_detalle = new GuiaremisionDetalle();
              //   this.guiaremision.detalle.forEach(venta_detalle => {
              //       guiaremision_detalle.cantidad = venta_detalle.cantidad;
              //       guiaremision_detalle.producto_id = venta_detalle.producto.id;
              //       guiaremision_detalle.producto.codigo = venta_detalle.producto.codigo;
              //       guiaremision_detalle.producto.descripcion = venta_detalle.producto.descripcion;
              //       guiaremision_detalle.producto.nombre = venta_detalle.producto.nombre;
              //       guiaremision_detalle.detalle = venta_detalle.detalle;
              //       this.guiaremision_detalle.push(guiaremision_detalle);
              //   });	
          },
          err => {
              this.loading = false;
          }
      );
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/guiaremision-modal/guiaremision-modal.component.ts